<template>
  <div class="trigger">
    <div class="question">{{ $t('promotion_new.items_precondition') }}</div>
    <div class="radios">
      <div class="radio">
        <input id="chk_item_precondition" type="radio" value="with_item" v-model="promotion.triggerType">
        <label for="chk_item_precondition">{{ $t('yes') }}</label>

      </div>
      <div class="radio">
        <input id="chk_no_item_precondition" type="radio" :value="''" v-model="promotion.triggerType">
        <label for="chk_no_item_precondition">{{ $t('no') }}</label>
      </div>
    </div>
    <template v-if="promotion.triggerType === 'with_item'">
      <div class="question">{{ $t('promotion_new.trigger_tags') }}</div>
      <MultiSelect :options="tags" :selected="promotion.triggerParameters.tags" :trackByAttribute="'value'"
                   @changed="promotion.triggerParameters.tags = $event"/>
    </template>
  </div>
</template>

<script>
import MultiSelect from "@/components/tools/MultiSelect";

export default {
  name: "PromotionTrigger",

  components: { MultiSelect },

  props: {
    promotion: Object,
    tags: Array
  }
}
</script>